import { render, staticRenderFns } from "./Captcha.vue?vue&type=template&id=32b44062&scoped=true&"
import script from "./Captcha.vue?vue&type=script&lang=js&"
export * from "./Captcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b44062",
  null
  
)

export default component.exports